import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const LeaveReasonRoutes = [
  {
    path: '/leave-reasons',
    name: 'ListLeaveReasons',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'leave_reason:list'
    }
  },
  {
    path: '/leave-reason/',
    name: 'CreateLeaveReason',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'leave_reason:create'
    }
  },
  {
    path: '/leave-reason/:id',
    name: 'UpdateLeaveReason',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'leave_reason:update'
    }
  },
  {
    path: '/leave-reason/view/:id',
    name: 'GetLeaveReason',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'leave_reason:get'
    }
  }
]
